<template>
	<div>
		<slot />
	</div>
</template>

<script setup>
	const props = defineProps({
		collapsable: {
			type: Boolean,
			default: false,
		},
	});

	const selected = ref();

	// provide data to child components
	provide('baseAccordionData', {
		selected,
		collapsable: props.collapsable,
	});
</script>
